import { useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { Flex } from "@similarweb/ui-components/foundations";

import { DefaultErrorBoundary } from "app/components/error-boundary-no-data";

import { MNP_TRADEMARK_ROUTES, mnpTrademarkNavigation } from "../../app/navigation";
import { useMonitorAndProtectCampaigns } from "../../services/api/campaign";
import { useGetTrademarks } from "../../services/api/trademarks";
import { ErrorCampaignState, PageLoadingState } from "../../shared/components/page-states";
import { MonitorAndProtectTrademarkSubNav } from "../../shared/trademark-sub-navigation";
import { Content } from "../../shared/ui/layout/content";
import { NavContainer } from "../../shared/ui/layout/navigation-container";

import { TrademarkDashboard } from "./trademark-violations.page";

export const TrademarkDashboardRoot = () => {
    const { isLoading: isLoadingTrademarks, data: trademarkList = [], isError: isErrorTrademarks } = useGetTrademarks();
    const { state } = useCurrentStateAndParams();
    const {
        isLoading: isLoadingCampaigns,
        data: campaignList = [],
        isError: isErrorCampaigns,
    } = useMonitorAndProtectCampaigns({ includeDemoCampaigns: false });

    useEffect(() => {
        if (
            isLoadingTrademarks ||
            isLoadingCampaigns ||
            isErrorCampaigns ||
            isErrorTrademarks ||
            state.name === MNP_TRADEMARK_ROUTES.trademarks
        ) {
            return;
        }

        const shouldRedirect = trademarkList.length === 0 || campaignList.length === 0;

        if (shouldRedirect) {
            void mnpTrademarkNavigation.trademarks.go();
        }

        return () => {};
    }, [
        campaignList,
        isErrorCampaigns,
        isErrorTrademarks,
        isLoadingCampaigns,
        isLoadingTrademarks,
        state.name,
        trademarkList,
    ]);

    if (isLoadingTrademarks || isLoadingCampaigns) {
        return <PageLoadingState />;
    }

    if (isErrorTrademarks || isErrorCampaigns) {
        return <ErrorCampaignState />;
    }

    return (
        <Flex
            height="100vh"
            flexDirection="column"
        >
            <NavContainer>
                <MonitorAndProtectTrademarkSubNav />
            </NavContainer>
            <Content>
                <DefaultErrorBoundary>
                    <TrademarkDashboard />
                </DefaultErrorBoundary>
            </Content>
        </Flex>
    );
};
